module.exports = __webpack_public_path__ + "img/closeWhiteIcon.20a90be7.png";